import React, { useState, useEffect } from 'react';
import { Drawer, Select, Button, Input, Space, Tag, Form, Spin, Card,Checkbox, message,DatePicker,Tooltip,Divider } from 'antd';
// import { Drawer, Button, Form, Card, Spin, Input, Checkbox, DatePicker, Space, Select, Tooltip, Avatar } from 'antd';
import { MailOutlined, InfoCircleOutlined, PhoneOutlined,PlusOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import DynamicSelect from '../Record/DynamicSelectForLookup';
import ReactQuill from 'react-quill';

import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant'; // Define the date format
import { ConsoleSqlOutlined, DeleteOutlined } from '@ant-design/icons';
import { convertToDateJSON } from '../Components/Utility';
dayjs.extend(customParseFormat);


const { Option } = Select;

const CreateNodeFlowDrawer = ({ visible, onClose, nodeData, onSave,selectedNode,setNodeData,isEditingMode,logbook="false",createRecordData }) => {
  const [objects, setObjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [selectedFields, setSelectedFields] = useState([]);
  const [fieldValues, setFieldValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const security=useSelector(state=>state.data.items[0]);
  const[selectedDate,setSelectedDate] = useState();
  const [objectName, setObjectName] = useState(null);
  const [fieldValuePairs, setFieldValuePairs] = useState([{ field: '', value: '' }]);
  const [selectedFieldNames, setSelectedFieldNames] = useState([]);

  useEffect(() => {
    const fetchObjects = async () => {
      try {
        setLoading(true);
        const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
        const response = await apiService.makeCall();
        setObjects(response);
      } catch (error) {
        console.error('Error fetching objects:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchObjects();
  }, []);
  
   // Populate data for edit mode when nodeData changes
   useEffect(() => {
        console.log('nodedata:::',nodeData);
        if (nodeData && Object.keys(nodeData).length > 0) {
        
        setName(nodeData?.label ? nodeData.label : nodeData.name || '');
        setApiName(nodeData?.apiName ? nodeData.apiName : nodeData.name || '');
        setDescription(nodeData.description || '');
        //   setSelectedObject(nodeData.parameters?.model || null);
        setObjectName(nodeData.parameters?.model || null);
        if (nodeData?.parameters?.fields) {
            const fieldPairs = Object.entries(nodeData.parameters.fields).map(
            ([field, value]) => ({ field, value })
            );
            setFieldValuePairs(fieldPairs);
            setFieldValuePairs(fieldPairs);
            setSelectedFieldNames(fieldPairs.map(pair => pair.field));          
        }
        // Fetch fields for the selected object if available
        if (nodeData.parameters?.model) {
            fetchFields(nodeData.parameters.model);
        }
        }
    
    else{
      setName('');
      setApiName('');
      setDescription('');
    //   setSelectedObject(null);
      setObjectName(null);
      setSelectedFields([]);
      setFieldValues({});
      setFieldValuePairs([{ field: '', value: '' }]);
      setSelectedFieldNames([]);
  
    }
  }, [visible]);
  
  
  const fetchFields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      const filteredFieldsData = (response).filter(
        field => !['recordCount', 'CreatedBy', 'LastModifiedBy','generate_new_password','User'].includes(field.name)  
        // && field.type !== 'Image'
    );
      setFields(filteredFieldsData);
    } catch (error) {
      console.error('Error fetching fields:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleObjectChange = (value) => {
    setObjectName(value);
    setFieldValuePairs([{ field: '', value: '' }]); // reset field-value pairs if needed
    // setSelectedObject(value);
    setSelectedFields([]); // Reset selected fields when object changes
    setFieldValues({}); // Reset field values
    fetchFields(value); // Fetch new fields for selected object
    setSelectedFieldNames([]);

  };

  const handleSave = () => {
    if (!name || !apiName || !objectName || fieldValuePairs.length === 0) {
      message.error('Please fill all required fields and add at least one field to update.');
      return;
    }
  
    // Validate that none of the fieldValuePairs have empty field names or empty values
    const invalidPair = fieldValuePairs.find(pair => !pair.field || pair.value === '');
    if (invalidPair) {
      message.error('Please select a field and enter a value for all field-value pairs.');
      return;
    }
  
    const type = 'Create Records';
    const id = selectedNode.id;

    const fallbackFields = nodeData?.parameters?.fields || {};

    const finalFields =
    fieldValuePairs.length > 0
        ? fieldValuePairs.reduce((acc, pair) => {
            acc[pair.field] = pair.value;
            return acc;
        }, {})
        : fallbackFields;

    const data = {
    name,
    type,
    id,
    apiName,
    description,
    parameters: {
        model: objectName || nodeData?.parameters?.model || '',
        fields: finalFields
    }
    };

    
    onSave(selectedNode.id, data); // Pass the data to the parent component
    // message.success('Record saved successfully!');
    // setNodeData([]);
    // onClose();
  };
  
  
  const handleCancel = () => {
    // Reset all fields when canceling
    // setSelectedObject(null);
    setObjectName(null);
    setSelectedFields([]);
    setFieldValues({});
    setFields([]);
    setName('');
    setApiName('');
    setDescription('');
    setNodeData([]);
    onClose(); // Close the drawer
    setSelectedFieldNames([]);

  };

  return (
    <Drawer
      title={` Create Records`}
      placement="right"
      width="40%"
      mask={false}
      zIndex={1002}   // higher than sidebar
      onClose={handleCancel} // Use handleCancel for closing
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
          <Button onClick={handleCancel} disabled={loading}>Cancel</Button>
          <Button type="primary" onClick={handleSave} disabled={loading}>Save</Button>
        </div>
      }
    >
      <Spin spinning={loading} tip="Loading...">
        <Card style={{ margin: '20px', padding: '20px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
          <Form layout="vertical">
            {/* <Form.Item label="Node ID">{nodeData?.id}</Form.Item>
            <Form.Item label="Node Label">{nodeData?.data?.label}</Form.Item> */}

            {/* Name Input */}
            <Form.Item label="Name" required>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter a name"
                onBlur={() => {
                  if (name) {
                    setApiName(
                      name
                        .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
                        .replace(/\s+/g, "") // Remove spaces
                        .trim()
                    );
                  }
                }}            
              />
            </Form.Item>

            {/* API Name Input */}
            <Form.Item label="API Name" required>
              <Input
                value={apiName}
                onChange={(e) => setApiName(e.target.value)}
                placeholder="Enter API name"
                disabled
              />
            </Form.Item>

            {/* Description Input */}
            <Form.Item label="Description">
              <Input.TextArea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description"
                rows={3}
              />
            </Form.Item>

            <Form.Item label="Object" required>
                <Select
                    value={objectName}
                    onChange={handleObjectChange}
                    placeholder="Select an object"
                >
                    {objects.map(obj => (
                    <Option key={obj._id} value={obj.name}>{obj.label}</Option>
                    ))}
                </Select>
                </Form.Item>

                <Divider style={{borderBlockStart: '2px solid #d9d9d9'}} orientation="left">Set Field Values for the {objectName || "Selected Object"}</Divider>

                {fieldValuePairs?.map((pair, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <Select
                    style={{ width: '40%' }}
                    placeholder="Select a field"
                    value={pair.field}
                    onChange={(value) => {
                        const newPairs = [...fieldValuePairs];
                        const prevField = newPairs[index].field;

                        // Update fieldValuePairs
                        newPairs[index].field = value;
                        setFieldValuePairs(newPairs);

                        // Update selected fields list
                        setSelectedFieldNames((prev) => {
                        const updated = [...prev];
                        if (prevField) {
                            const idx = updated.indexOf(prevField);
                            if (idx !== -1) updated.splice(idx, 1);
                        }
                        if (value) updated.push(value);
                        return updated;
                        });
                    }}
                    >
                    {fields
                        .filter(field => !selectedFieldNames.includes(field.name) || pair.field === field.name)
                        .map(field => (
                        <Option key={field.name} value={field.name}>{field.label}</Option>
                        ))}
                    </Select>

                    <span style={{ margin: '0 10px' }}>←</span>

                    <Input
                    style={{ width: '40%' }}
                    placeholder="Enter value"
                    value={pair.value}
                    onChange={(e) => {
                        const newPairs = [...fieldValuePairs];
                        newPairs[index].value = e.target.value;
                        setFieldValuePairs(newPairs);
                    }}
                    />

                    <Button
                    icon={<DeleteOutlined />}
                    danger
                    onClick={() => {
                        const removedField = fieldValuePairs[index].field;
                        const newPairs = fieldValuePairs.filter((_, i) => i !== index);
                        setFieldValuePairs(newPairs);
                    
                        setSelectedFieldNames((prev) => prev.filter((field) => field !== removedField));
                      }}
                    
                    
                    style={{ marginLeft: 10 }}
                    />
                </div>
                ))}

                <Button type="dashed" onClick={() => setFieldValuePairs([...fieldValuePairs, { field: '', value: '' }])} icon={<PlusOutlined />}>
                Add Field
                </Button>



          </Form>
        </Card>
      </Spin>
    </Drawer>
  );
};

export default CreateNodeFlowDrawer;
